import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FleetBoardModalComponent } from 'src/app/components/profile/fleet-board-modal/fleet-board-modal.component';
import { FleetNodeModalComponent } from 'src/app/components/profile/fleet-node-modal/fleet-node-modal.component';
import { FleetApiService } from 'src/app/services/api/fleet-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-fleet-page',
  templateUrl: './user-profile-fleet-page.component.html',
  styleUrls: ['./user-profile-fleet-page.component.scss'],
})
export class UserProfileFleetPageComponent implements OnInit {
  pageSize = 10000;
  isPopupVisible = false;
  modelConfigs = [
    { model: 'o1-p', label: '本周剩余次数' },
    { model: '4/4o', label: '6小时剩余次数' },
    { model: 'o1-mini', label: '24小时剩余次数' },
  ];

  constructor(
    private dialog: MatDialog,
    private api: FleetApiService,
    private message: MessageService,
    private apiUser: UserApiService
  ) {
  }

  ngOnInit(): void {
    this.getSeat();
    this.checkAnnouncementStatus();
  }

  seat: any;
  modelsOriginally: any;
  async getSeat() {
    try {
      this.loading = true;
      const r = await this.apiUser.getChatgptCount('Active', '');
      this.seat = r.data;
      this.modelsOriginally = this.seat;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
      this.getFleetAuthTokens();
    }
  }

  calculatePercent(remain: any, times: any): number {
    const remainValue = Number(remain);
    const timesValue = Number(times);
    return timesValue ? (remainValue / timesValue) * 100 : 0;
  }

  checkNode() {
    //目前只有一个节点先不用
    // this.dialog.open(FleetNodeModalComponent, {
    //   data: this.tokens,
    //   panelClass: 'fleet-node-dialog',
    // });
  }

  visit() {}

  openBoard() {
    this.dialog.open(FleetBoardModalComponent, {});
  }

  async checkAnnouncementStatus() {
    try {
      const r = await this.apiUser.checkAnnouncementStatus();
      const status = r.data[0].is_computer;
      if (!status) {
        this.openBoard();
      }
    } catch (error) {}
  }

  explain() {
    this.isPopupVisible = !this.isPopupVisible;
  }

  cards: any[] = [];
  loading = false;
  findFleetCards = async () => {
    try {
      const r = await this.apiUser.findFleetCards(
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization,
        1,
        1,
        this.pageSize
      );
      const list = r.data.list || [];
      this.cards = list;
    } catch (error) {
      this.message.open('网络错误');
    }
  };

  tokens: any;
  async getFleetAuthTokens() {
    try {
      this.loading = true;
      const r = await this.apiUser.getFleetAuthTokens();
      this.tokens = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
      // this.findNodes();
      this.loginFleet();
    }
  }

  nodeList: any;
  node_id: any;
  nodesLoaded = false;
  async findNodes() {
    try {
      this.loading = true;
      const r = await this.api.findNodes(
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization
      );
      this.nodeList = r.data.list;
      this.node_id = this.nodeList[0].id;
      this.nodesLoaded = true;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  models: any;

  format = (item: any) => (): string => {
    return `${item?.remain}`;
  };

  //先调用登录接口 来校对次数
  async getOfficialUserRemain() {
    try {
      this.loading = true;
      const r = await this.apiUser.getOfficialUserRemain(
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization
      );
      this.models = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  async loginFleet() {
    try {
      this.loading = true;
      const r = await this.apiUser.loginFleet(
        this.seat.car,
        this.seat.current,
        this.seat.duration,
        this.seat.sign,
        this.seat.times,
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization
      );
      if (r.code === 200) {
        this.getOfficialUserRemain();
      } else if (r.code === 10001) {
        this.message.open('没有权限');
      } else {
        this.message.open('未知错误');
      }
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
}
